import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveyService } from '../services/survey.service';
import {CdkDrag, CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { GlobalServices } from '../global.services';
declare var $: any;

@Component({
  selector: 'app-onboard-questions',
  templateUrl: './onboard-questions.component.html',
  styleUrls: ['./onboard-questions.component.scss']
})
export class OnboardQuestionsComponent implements OnInit {

  constructor(private surveyService: SurveyService,
    private formBuilder: FormBuilder,
    private router: Router,
    private globalService: GlobalServices,
    private activatedRoute: ActivatedRoute) { }
  
  displaySection = 1; 
  public responseMessage: string = "";
  public showAlert: boolean = false;
  ngOnInit(): void {
    if(this.globalService.isBrowser){
      // if ( $('[type="date"]').prop('type') == 'date' ) {
      //   $('[type="date"]').datepicker();
      // }
      // $(document).ready(function(){
      //   if ( $('#dob').prop('type') != 'date' ) $('#dob').datepicker();
      //   if ( $('#dob').prop('type') == 'date' ) $('#dob').datepicker();
      // });
      if(this.globalService.isLoggedIn == true){
        this.getSurveyQuestion();
        this.formGroupOneInit();
        // if(document.getElementById("dob")){
        //   document.getElementById("dob").onclick = function(e){
        //     document.getElementById("dob")?.click();
        //     // You could write code to toggle this
        //   }
        // }
        this.activatedRoute.params.subscribe((paramsCatched: any) => {
          // console.log('paramsCatched', paramsCatched);
          // if it is for EDIT MODE
          if(paramsCatched.edit == "true"){
            this.displaySection = 2;
            this.moveToTop();
          }
        })
      }else{
        this.router.navigate([''])
      }
    }
     
  }
  surveyData;
  getSurveyQuestion(){
    this.surveyService.getSurveyQuestions().subscribe((resOfSurveyQuestion: any) => {
      // console.log('getSurveyQuestion', resOfSurveyQuestion);
      if(resOfSurveyQuestion){
        if(resOfSurveyQuestion?.mappings?.PLATFORMS){
          this.setByDefaultToRankServiceField(resOfSurveyQuestion?.mappings?.PLATFORMS);
          resOfSurveyQuestion.mappings.PLATFORMS = this.returnArrayForObjectsKeysValues(resOfSurveyQuestion?.mappings?.PLATFORMS);
        }
        this.surveyData = Object.assign( {}, resOfSurveyQuestion ) ;
      this.getDataOfAlreadyFillSurveyByUser(); // call for bindings form values in EDIT mode
      }
    });
  }

formGroupOne: FormGroup;
formGroupOneInit(){
  this.formGroupOne = this.formBuilder.group({
    dob:['1996-01-14', Validators.required],
    country:['5dc58a542796bd4d6a014c0b', Validators.required],
    state:['5dc58a562796bd4d6a01594d', Validators.required],
    gender:['male', Validators.required],
    rankService: [[]]
  })
}
 setByDefaultToRankServiceField(objectPassed){
  if(objectPassed){
    let arrToSetByDefault = [];
    Object.keys(objectPassed).map((obj)=> {
      arrToSetByDefault.push(obj)
    })
    // console.log('setByDefaultToRankServiceField',arrToSetByDefault);
    // this.formGroupOne.value.rankService = arrToSetByDefault;
    this.formGroupOne.patchValue({
      rankService : arrToSetByDefault
    })
  }
}
questionSelectionOne(questionNumber, value){
  // console.log('questionSelection', questionNumber, value, this.formGroupOne.value.rankService);
  if(this.formGroupOne.value.rankService.includes(value)){
    const ind = this.formGroupOne.value.rankService.indexOf(value);
    this.formGroupOne.value.rankService.splice(ind, 1);
    return;
  }
  this.formGroupOne.value.rankService.push(value);
}

public findInvalidControls() {
  const invalid = [];
  const controls = this.formGroupOne.controls;
  for (const name in controls) {
      if (controls[name].invalid) {
          invalid.push(name);
      }
  }
  return invalid;
}


formGroupOneValidThenOnlyMoveForward(){
  // const ok = this.findInvalidControls();
  // console.log('formGroupOneValidThenOnlyMoveForward', this.formGroupOne, this.formGroupOne.value.rankService, this.formGroupOne.value.rankService?.length, this.formGroupOne.value.rankService?.length > 0);
  if(this.formGroupOne.value.rankService?.length == 0){
    this.showAlert = true;
    this.responseMessage = 'Please select atleast one rank service !!';
    return;
  }
  if(this.formGroupOne.valid ){
    this.displaySection = 3;
    this.initiateFormGroupSecond();
    this.moveToTop();
  }else{
    this.showAlert = true;
    this.responseMessage = 'Please complete First questionare';
    return;
  }
  
}
formGroupTwo: FormGroup;
initiateFormGroupSecond(){
  this.formGroupTwo = this.formBuilder.group({
    checkAllAreasOfInterest : [[]],
    goals:[[]],
    questionSecondSectionGoalsOther: [],
    categoriesOfInterest : [[]],
    otherInSecondQuestionCategoriesOfInterest: [],
  });
  this.fillFormGroupSecond();
}

questionSelectionSecondSectionInterest(value){
    // console.log('questionSelectionSecondSectionInterest', value, this.formGroupTwo.value.checkAllAreasOfInterest);
    if(this.formGroupTwo.value.checkAllAreasOfInterest.includes(value)){
      const ind = this.formGroupTwo.value.checkAllAreasOfInterest.indexOf(value);
      this.formGroupTwo.value.checkAllAreasOfInterest.splice(ind, 1);
      this.formGroupTwo.value.checkAllAreasOfInterest = this.formGroupTwo.value.checkAllAreasOfInterest.map((obj: any) => {
        return obj;
      })
      // console.log('questionSelectionSecondSectionInterest2', this.formGroupTwo.value.checkAllAreasOfInterest);
      return;
    }
    this.formGroupTwo.value.checkAllAreasOfInterest = [...this.formGroupTwo.value.checkAllAreasOfInterest, ...[value]];
    // console.log('questionSelectionSecondSectionInterest3', this.formGroupTwo.value.checkAllAreasOfInterest);
}
questionSelectionSecondSectionGoals(value){
    // console.log('questionSelectionSecondSectionGoals', value, this.formGroupTwo.value.goals);
    if(this.formGroupTwo.value.goals.includes(value)){
      const ind = this.formGroupTwo.value.goals.indexOf(value);
      this.formGroupTwo.value.goals.splice(ind, 1);
      this.formGroupTwo.value.goals = [...this.formGroupTwo.value.goals, ...[]];
      return;
    }
    this.formGroupTwo.value.goals = [...this.formGroupTwo.value.goals, ...[value]];
    // this.formGroupTwo.value.goals.push(value);
}
questionSelectionSecondSectionCategoriesOfInterest(value){
    // console.log('questionSelectionSecondSectionCategoriesOfInterest', value, this.formGroupTwo.value.categoriesOfInterest);
    if(this.formGroupTwo.value.categoriesOfInterest.includes(value)){
      const ind = this.formGroupTwo.value.goals.indexOf(value);
      this.formGroupTwo.value.categoriesOfInterest.splice(ind, 1);
      this.formGroupTwo.value.categoriesOfInterest = [...this.formGroupTwo.value.categoriesOfInterest, ...[]];
      return;
    }
    this.formGroupTwo.value.categoriesOfInterest = [...this.formGroupTwo.value.categoriesOfInterest, ...[value]];
    // this.formGroupTwo.value.categoriesOfInterest.push(value);
}
nextQuestionClickedOnSecondQuestionSection(){
    // console.log('nextQuestionClickedOnSecondQuestionSection', this.formGroupTwo, this.formGroupTwo.valid, this.formGroupTwo.value.questionSecondSectionGoalsOther, this.formGroupTwo.value);
    if(this.formGroupTwo.value.checkAllAreasOfInterest.length ==  0){
      this.showAlert = true;
      this.responseMessage = 'Please select Areas Of Interest !!';
        return;
    }
    if(this.formGroupTwo.value.goals.length ==  0 && this.formGroupTwo.value.questionSecondSectionGoalsOther == null){
      this.showAlert = true;
      this.responseMessage = 'Please select or fill goals !!'
        return;
    }
    if(this.formGroupTwo.value.categoriesOfInterest.length ==  0 && this.formGroupTwo.value.otherInSecondQuestionCategoriesOfInterest == null){
      this.showAlert = true;
      this.responseMessage = 'Please select or fill categories of interest !!';
        return;
    }
    
    if(this.formGroupTwo.valid){
        this.displaySection = 4;
        this.initiateFormGroupThird();
        this.moveToTop();
        // setTimeout(() => {
        //   this.fillFormGroupThird();
        // }, 2000);
    }else{
      this.showAlert = true;
      this.responseMessage = 'second questionaire fill completely';
        return;
    }
}

formGroupThird: FormGroup;
initiateFormGroupThird(){
  // console.log('initiateFormGroupThird');
    this.formGroupThird = this.formBuilder.group({
        checkAllAreasOfInterest: [ [], Validators.required],
        travelTypeInterestedIn: [ [], Validators.required],
        travelStyleInterestedIn: [ [], Validators.required],
        topThreeLocationOfInterestInUsaFieldFirst: ['5dc58a562796bd4d6a01594d' ],
        topThreeLocationOfInterestInUsaFieldSecond: ['5dc58a562796bd4d6a015949'],
        topThreeLocationOfInterestInUsaFieldThird: ['5dc58a562796bd4d6a01594b'],
        topThreeLocationOfInterestInternationalFieldFirst: ['5dc58a542796bd4d6a014c0b'],
        topThreeLocationOfInterestInternationalFieldSecond: ['5dc58a542796bd4d6a014bf9'],
        topThreeLocationOfInterestInternationalFieldThird: ['5dc58a542796bd4d6a014bc3'],
        categoriesOfInterest : [[], Validators.required],
        thirdSectionCategoriesOfInterestOtherField : ['']
    })
    this.fillFormGroupThird();
}

thirdSectioncheckAllAreasOfInterest(value){
    // console.log('thirdSectioncheckAllAreasOfInterest', value, this.formGroupThird.value.checkAllAreasOfInterest);
    if(this.formGroupThird.value.checkAllAreasOfInterest.includes(value)){
      const ind = this.formGroupThird.value.checkAllAreasOfInterest.indexOf(value);
      this.formGroupThird.value.checkAllAreasOfInterest.splice(ind, 1);
      // this.formGroupThird.value.checkAllAreasOfInterest = [...this.formGroupThird.value.checkAllAreasOfInterest, ...[]];
      this.formGroupThird.patchValue({
        checkAllAreasOfInterest: [...this.formGroupThird.value.checkAllAreasOfInterest, ...[]]
      })
      return;
    }
    this.formGroupThird.patchValue({
      checkAllAreasOfInterest: [...this.formGroupThird.value.checkAllAreasOfInterest, ...[value]]
    })
    // this.formGroupThird.value.checkAllAreasOfInterest = [...this.formGroupThird.value.checkAllAreasOfInterest, ...[value]];
    // this.formGroupThird.value.checkAllAreasOfInterest.push(value);
    // console.log('thirdSectioncheckAllAreasOfInterest', this.formGroupThird.value.checkAllAreasOfInterest);
}
thirdSectionTravelTypeInterestedIn(value){
    // console.log('thirdSectionTravelTypeInterestedIn', value, this.formGroupThird.value.travelTypeInterestedIn);
    if(this.formGroupThird.value.travelTypeInterestedIn.includes(value)){
      const ind = this.formGroupThird.value.travelTypeInterestedIn.indexOf(value);
      this.formGroupThird.value.travelTypeInterestedIn.splice(ind, 1);
      // this.formGroupThird.value.travelTypeInterestedIn = [...this.formGroupThird.value.travelTypeInterestedIn, ...[]];
      this.formGroupThird.patchValue({
        travelTypeInterestedIn: [...this.formGroupThird.value.travelTypeInterestedIn, ...[]]
      })
      return;
    }
    // this.formGroupThird.value.travelTypeInterestedIn = [...this.formGroupThird.value.travelTypeInterestedIn, ...[value]];
    this.formGroupThird.patchValue({
      travelTypeInterestedIn: [...this.formGroupThird.value.travelTypeInterestedIn, ...[value]]
    })
    // this.formGroupThird.value.travelTypeInterestedIn.push(value);
}
thirdSectionTravelStyleInterestedIn(value){
    // console.log('thirdSectionTravelStyleInterestedIn', value, this.formGroupThird.value.travelStyleInterestedIn);
    if(this.formGroupThird.value.travelStyleInterestedIn.includes(value)){
      const ind = this.formGroupThird.value.travelStyleInterestedIn.indexOf(value);
      this.formGroupThird.value.travelStyleInterestedIn.splice(ind, 1);
      // this.formGroupThird.value.travelStyleInterestedIn = [...this.formGroupThird.value.travelStyleInterestedIn, ...[]];
      this.formGroupThird.patchValue({
        travelStyleInterestedIn: [...this.formGroupThird.value.travelStyleInterestedIn, ...[]]
      })
      return;
    }
    // this.formGroupThird.value.travelStyleInterestedIn = [...this.formGroupThird.value.travelStyleInterestedIn, ...[value]];
    this.formGroupThird.patchValue({
      travelStyleInterestedIn: [...this.formGroupThird.value.travelStyleInterestedIn, ...[value]]
    })
    // this.formGroupThird.value.travelStyleInterestedIn.push(value);
}
thirdSectionCategoriesOfInterest(value){
    // console.log('thirdSectionCategoriesOfInterest', value, this.formGroupThird.value.categoriesOfInterest);
    if(this.formGroupThird.value.categoriesOfInterest.includes(value)){
      const ind = this.formGroupThird.value.categoriesOfInterest.indexOf(value);
      this.formGroupThird.value.categoriesOfInterest.splice(ind, 1);
      // this.formGroupThird.value.categoriesOfInterest = [...this.formGroupThird.value.categoriesOfInterest, ...[]];
      this.formGroupThird.patchValue({
        categoriesOfInterest: [...this.formGroupThird.value.categoriesOfInterest, ...[]]
      })
      return;
    }
    // this.formGroupThird.value.categoriesOfInterest = [...this.formGroupThird.value.categoriesOfInterest, ...[value]];
    this.formGroupThird.patchValue({
      categoriesOfInterest: [...this.formGroupThird.value.categoriesOfInterest, ...[value]]
    })
    // this.formGroupThird.value.categoriesOfInterest.push(value);
}

nextQuestionClickedOnThirdQuestionSection(){
    if(this.formGroupThird.value.checkAllAreasOfInterest.length == 0){
      this.showAlert = true;
      this.responseMessage = 'Please select atleast one Areas Of Interest !!'
        return;
    }
    if(this.formGroupThird.value.travelTypeInterestedIn.length == 0){
      this.showAlert = true;
      this.responseMessage = 'Please select atleast one Travel Type Interested In !!';
        return;
    }
    if(this.formGroupThird.value.travelStyleInterestedIn.length == 0){
      this.showAlert = true;
      this.responseMessage ='Please select atleast one Travel Style Interested In !!';  
      return;
    }
    if(this.formGroupThird.value.topThreeLocationOfInterestInUsaFieldFirst == null  || 
        this.formGroupThird.value.topThreeLocationOfInterestInUsaFieldSecond == null ||
        this.formGroupThird.value.topThreeLocationOfInterestInUsaFieldThird == null){
          this.showAlert = true;
          this.responseMessage = 'Please select all three Location in USA !!';
        return;
    }
    if(this.formGroupThird.value.topThreeLocationOfInterestInternationalFieldFirst == null  || 
        this.formGroupThird.value.topThreeLocationOfInterestInternationalFieldSecond == null ||
        this.formGroupThird.value.topThreeLocationOfInterestInternationalFieldThird == null){
          this.showAlert = true;
          this.responseMessage = 'Please select all three Location Internationally !!';
        return;
    }
    if(this.formGroupThird.value.categoriesOfInterest.length == 0 && this.formGroupThird.value.thirdSectionCategoriesOfInterestOtherField == null){
      this.showAlert = true;
      this.responseMessage = 'Please select atleast one category of  interest or fill other field !!';
        return;
    }
    
    if(this.formGroupThird.valid){
        this.displaySection = 5;
        this.initiateFormGroupFourth();
        this.moveToTop();
        // setTimeout(() => {
        //   this.fillFormGroupFourth()
        // }, 2000);
    }else{
      this.showAlert = true;
      this.responseMessage = 'Please fill section third completely !!';
        return;
    }
}

formGroupFourth: FormGroup;
initiateFormGroupFourth(){
    this.formGroupFourth = this.formBuilder.group({
        categoriesOfInterest: [[]],
        sectionFourthCategoriesOfInterestOther: []
    })
    this.fillFormGroupFourth();
}

sectionFourthCategoriesOfInterest(value){
    // console.log('sectionFourthCategoriesOfInterest', value, this.formGroupFourth.value.categoriesOfInterest);
    if(this.formGroupFourth.value.categoriesOfInterest.includes(value)){
      const ind = this.formGroupFourth.value.categoriesOfInterest.indexOf(value);
      this.formGroupFourth.value.categoriesOfInterest.splice(ind, 1);
      this.formGroupFourth.value.categoriesOfInterest = [...this.formGroupFourth.value.categoriesOfInterest, ...[]];
      return;
    }
    this.formGroupFourth.value.categoriesOfInterest = [...this.formGroupFourth.value.categoriesOfInterest, ...[value]];
    // this.formGroupFourth.value.categoriesOfInterest.push(value);
}

submitQuestionaire(){
  // console.log('submitQuestionaire' , this.formGroupOne, this.formGroupTwo, this.formGroupThird, this.formGroupFourth, 
  // (this.formGroupFourth.value.categoriesOfInterest.length == 0), this.formGroupFourth.value.categoriesOfInterest.length, this.formGroupFourth.value.sectionFourthCategoriesOfInterestOther);
  if(this.formGroupFourth.value.sectionFourthCategoriesOfInterestOther == null && this.formGroupFourth.value.categoriesOfInterest.length == 0){
    this.showAlert = true;
    this.responseMessage = 'Please select interest or fill it !!';
    return;
  }

  let objSend = {
    dob: this.formGroupOne.value.dob,
	location: {
		country: this.formGroupOne.value.country,
		state: this.formGroupOne.value.state
	},
	gender: this.formGroupOne.value.gender,
    servicePreferenceOrder: this.formGroupOne.value.rankService,
    platform: {
		digital: {
			products: this.formGroupTwo.value.checkAllAreasOfInterest,
			categories: {
				predefined: this.formGroupTwo.value.categoriesOfInterest,
        others : [this.formGroupTwo.value.otherInSecondQuestionCategoriesOfInterest ? this.formGroupTwo.value.otherInSecondQuestionCategoriesOfInterest : '']
			},
			goals: {
				predefined: this.formGroupTwo.value.goals,
        others: [ this.formGroupTwo.value.questionSecondSectionGoalsOther ? this.formGroupTwo.value.questionSecondSectionGoalsOther : '' ]
			}
		},
		travel: {
			products: this.formGroupThird.value.checkAllAreasOfInterest,
			travelType: this.formGroupThird.value.travelTypeInterestedIn,
			travelStyle: this.formGroupThird.value.travelStyleInterestedIn,
			categories: {
				predefined: this.formGroupThird.value.categoriesOfInterest,
				others: [ this.formGroupThird.value.thirdSectionCategoriesOfInterestOtherField ? this.formGroupThird.value.thirdSectionCategoriesOfInterestOtherField : '' ]
			},
			topThreeLocations: {
                usaStates: [this.formGroupThird.value.topThreeLocationOfInterestInUsaFieldFirst, 
                    this.formGroupThird.value.topThreeLocationOfInterestInUsaFieldSecond, 
                    this.formGroupThird.value.topThreeLocationOfInterestInUsaFieldThird    ],
				international: [
                    this.formGroupThird.value.topThreeLocationOfInterestInternationalFieldFirst,
                    this.formGroupThird.value.topThreeLocationOfInterestInternationalFieldSecond,
                    this.formGroupThird.value.topThreeLocationOfInterestInternationalFieldThird
                ]
			}
		},
		shop: {
			categories: {
				predefined: this.formGroupFourth.value.categoriesOfInterest,
				others: [ this.formGroupFourth.value.sectionFourthCategoriesOfInterestOther ? this.formGroupFourth.value.sectionFourthCategoriesOfInterestOther : '' ]
			}
		}
	}
  };
  // console.log('submitQuestionaire2', objSend);
  //return
  this.surveyService.postQuestionaireData(objSend).subscribe((resOfQuestionaireDataSubmitted: any) => {
      // console.log('resOfQuestionaireDataSubmitted', resOfQuestionaireDataSubmitted);
      if(resOfQuestionaireDataSubmitted){
        this.showAlert = true;
        this.responseMessage = 'Thank you for your submission !';
        setTimeout(() => {
          this.router.navigate(['home']);
        },2000)
      }
  })
}

public triggerCloseEvent() {
  this.showAlert = false;
}


returnArrayForObjectsKeysValues(objectPassed){
  // console.log('returnArrayForObjectsKeysValues', objectPassed);
  if(objectPassed){
    let arrSendInReturn = [];
    Object.keys(objectPassed).map(function (key) { 
      // Using Number() to convert key to number type
      // Using obj[key] to retrieve key value
      arrSendInReturn.push( {key: key, value: objectPassed[key] })
      // return [key, objectPassed[key]]; 
    }); 
    // console.log('returnArrayForObjectsKeysValues2', arrSendInReturn);
    return arrSendInReturn;
  }
}

servicesList;

// onDrop(event){
  // }
  onDrop(event: CdkDragDrop<string[]>) {
      // console.log('eventCatched', event, event.container.data,'-->',event.previousIndex, event.currentIndex, 
      // '-->', (event.currentIndex == 0));
  
  if (event.previousContainer === event.container) {
     moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
     setTimeout(() => {
       let arr= []
       event.container.data.map((obj) => {
        arr.push(obj['key'])
       })
      this.formGroupOne.patchValue({
        rankService: arr
      })
     },2000)
  } else {
     transferArrayItem(event.previousContainer.data,
     event.container.data,
     event.previousIndex,
     event.currentIndex);
  }
}

userSpecificSurveyDataSavedInDB;
getDataOfAlreadyFillSurveyByUser(){
  let userDetails = JSON.parse(localStorage.getItem('userDetails'));
  // console.log('getDataOfAlreadySurveyFillByUser', userDetails?._id);
  if(userDetails?._id){
    this.surveyService.getUserSpecificUserSurveyData(userDetails?._id).subscribe((resOfUserData: any) => {
      // console.log('getDataOfAlreadySurveyFillByUser2', resOfUserData, resOfUserData?.data);
      if(resOfUserData?.data){
        this.userSpecificSurveyDataSavedInDB = resOfUserData?.data;
      }
      // console.log('getDataOfAlreadySurveyFillByUser3', new Date(resOfUserData?.userDetail.DOB).getFullYear(), (new Date(resOfUserData?.userDetail.DOB).getMonth()+1), new Date(resOfUserData?.userDetail.DOB).getDate(), new Date(resOfUserData?.userDetail.DOB).getFullYear()+'-'+(new Date(resOfUserData?.userDetail.DOB).getMonth()+1).toString().padStart(2,"0")+'-'+new Date(resOfUserData?.userDetail.DOB).getDate(),
      // (new Date(resOfUserData?.userDetail.DOB).getFullYear()+'-'+(new Date(resOfUserData?.userDetail.DOB).getMonth()+1).toString().padStart(2,"0")+'-'+new Date(resOfUserData?.userDetail.DOB).getDate()).toString());
      if(resOfUserData?.data?.servicePreferenceOrder?.length > 0){
        let arOfPlatformsMapping = [];
        // let indexOfLiveWell = resOfUserData?.data?.servicePreferenceOrder?.indexOf("LIVE_WELL");
        // let indexOfShopWell = resOfUserData?.data?.servicePreferenceOrder?.indexOf("SHOP_WELL");
        // let indexOfTravelWell = resOfUserData?.data?.servicePreferenceOrder?.indexOf("TRAVEL_WELL");
        for(let i = 0; i < resOfUserData?.data?.servicePreferenceOrder?.length; i++ ){
          this.surveyData?.mappings?.PLATFORMS?.forEach((obj: any) => {
            if(obj?.key == resOfUserData?.data?.servicePreferenceOrder[i]){
              arOfPlatformsMapping.push(obj);
            }
          });
        }
        // console.log('getDataOfAlreadySurveyFillByUser3', arOfPlatformsMapping);
        this.surveyData.mappings.PLATFORMS = arOfPlatformsMapping;
      }
      if(resOfUserData?.userDetail){

        this.formGroupOne?.patchValue({
        //   dob: resOfUserData?.userDetail?.DOB ? (new Date(resOfUserData?.userDetail.DOB).getFullYear()+'-'+(new Date(resOfUserData?.userDetail.DOB).getMonth()+1).toString().padStart(2,"0")+'-'+new Date(resOfUserData?.userDetail.DOB).getDate().toString().padStart(2,"0")).toString() : 
        // '1996-01-14',
        dob: resOfUserData?.userDetail?.DOB ? resOfUserData?.userDetail?.DOB : 
        '1996-01-14',
          country:resOfUserData?.userDetail?.country?._id ? resOfUserData?.userDetail.country?._id : '5dc58a542796bd4d6a014c0b',
          state:resOfUserData?.userDetail?.state?._id ? resOfUserData?.userDetail?.state?._id : '5dc58a562796bd4d6a01594d',
          // state: resOfUserData?.userDetail?.state?.name ? resOfUserData?.userDetail?.state?.name : 'california',
          gender: resOfUserData?.userDetail.gender ? resOfUserData?.userDetail.gender : 'male',
        })
        
      }
    });
  }
}

fillFormGroupSecond(){
  this.formGroupTwo.patchValue({
    checkAllAreasOfInterest : this.userSpecificSurveyDataSavedInDB?.platform?.digital?.products ? this.userSpecificSurveyDataSavedInDB?.platform?.digital?.products : [],
    goals: this.userSpecificSurveyDataSavedInDB?.platform?.digital?.goals?.predefined ? this.userSpecificSurveyDataSavedInDB?.platform?.digital?.goals?.predefined : [],
    questionSecondSectionGoalsOther: this.userSpecificSurveyDataSavedInDB?.platform?.digital?.goals?.others[0] ? this.userSpecificSurveyDataSavedInDB?.platform?.digital?.goals?.others[0] : '',
    categoriesOfInterest : this.userSpecificSurveyDataSavedInDB?.platform?.digital?.categories?.predefined ? this.userSpecificSurveyDataSavedInDB?.platform?.digital?.categories?.predefined : [],
    otherInSecondQuestionCategoriesOfInterest: this.userSpecificSurveyDataSavedInDB?.platform?.digital?.categories?.others[0] ? this.userSpecificSurveyDataSavedInDB?.platform?.digital?.categories?.others[0] : '',
  });
}
fillFormGroupThird(){ 
  if(this.userSpecificSurveyDataSavedInDB){
    // console.log('fillFormGroupThird_1', this.formGroupThird?.getRawValue() , this.userSpecificSurveyDataSavedInDB?.platform?.travel?.products);
    this.formGroupThird?.patchValue({
      checkAllAreasOfInterest: this.userSpecificSurveyDataSavedInDB?.platform?.travel?.products ? this.userSpecificSurveyDataSavedInDB?.platform?.travel?.products : [],
      travelTypeInterestedIn: this.userSpecificSurveyDataSavedInDB?.platform?.travel?.travelType ? this.userSpecificSurveyDataSavedInDB?.platform?.travel?.travelType : [],
      travelStyleInterestedIn: this.userSpecificSurveyDataSavedInDB?.platform?.travel?.travelStyle ? this.userSpecificSurveyDataSavedInDB?.platform?.travel?.travelStyle : [],
  
      topThreeLocationOfInterestInUsaFieldFirst: this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.usaStates[0] ? 
                                                  this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.usaStates[0] : 
                                                  '5dc58a562796bd4d6a01594d',
      topThreeLocationOfInterestInUsaFieldSecond: this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.usaStates[1] ? 
                                                  this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.usaStates[1] :
                                                  '5dc58a562796bd4d6a015949',
      topThreeLocationOfInterestInUsaFieldThird: this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.usaStates[2] ? 
                                                  this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.usaStates[2] :
                                                  '5dc58a562796bd4d6a01594b',
  
      topThreeLocationOfInterestInternationalFieldFirst: this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.international[0] ?
                                                          this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.international[0] :
                                                          '5dc58a542796bd4d6a014c0b',
      topThreeLocationOfInterestInternationalFieldSecond: this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.international[1] ?
                                                          this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.international[1] :
                                                          '5dc58a542796bd4d6a014bf9',
      topThreeLocationOfInterestInternationalFieldThird: this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.international[2] ?
                                                          this.userSpecificSurveyDataSavedInDB?.platform?.travel?.topThreeLocations?.international[2] :
                                                          '5dc58a542796bd4d6a014bc3',
                                                          
      categoriesOfInterest : this.userSpecificSurveyDataSavedInDB?.platform?.travel?.categories?.predefined ? this.userSpecificSurveyDataSavedInDB?.platform?.travel?.categories?.predefined : [],
      thirdSectionCategoriesOfInterestOtherField : this.userSpecificSurveyDataSavedInDB?.platform?.travel?.categories?.others[0] ? this.userSpecificSurveyDataSavedInDB?.platform?.travel?.categories?.others[0] : '',
  })
  }
// console.log('fillFormGroupThird_2', this.formGroupThird?.getRawValue() , this.userSpecificSurveyDataSavedInDB?.platform?.travel?.products, this.formGroupThird?.controls.checkAllAreasOfInterest);
// this.formGroupThird.valueChanges.subscribe(x => {
//   console.log('form value changed', x);
// })

}

fillFormGroupFourth(){
  this.formGroupFourth?.patchValue({
    categoriesOfInterest: this.userSpecificSurveyDataSavedInDB?.platform?.shop?.categories?.predefined ? this.userSpecificSurveyDataSavedInDB?.platform?.shop?.categories?.predefined : [],
    sectionFourthCategoriesOfInterestOther: this.userSpecificSurveyDataSavedInDB?.platform?.shop?.categories?.others[0] ? this.userSpecificSurveyDataSavedInDB?.platform?.shop?.categories?.others[0] : '',
})
}

moveToTop(){
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}
selectedMonthSelected(eventPassed){
  // console.log('selectedMonthSelected1_eventPassed', eventPassed.value, (eventPassed.value.getFullYear()+'-'+(eventPassed.value.getMonth()+1).toString().padStart(2,'0')+'-'+eventPassed.value.getDate().toString().padStart(2,'0')));
  if(eventPassed?.value){
    this.formGroupOne?.patchValue({
      dob: (eventPassed.value.getFullYear()+'-'+(eventPassed.value.getMonth()+1).toString().padStart(2,'0')+'-'+eventPassed.value.getDate().toString().padStart(2,'0')) ? 
      (eventPassed.value.getFullYear()+'-'+(eventPassed.value.getMonth()+1).toString().padStart(2,'0')+'-'+eventPassed.value.getDate().toString().padStart(2,'0')) : 
    '1996-01-14'
    })
  }
}

}
